import { Button, Flex } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { useTranslation } from "react-i18next";
import React from "react";

type SubHeaderType = {
  title: string;
  saveData: () => void;
  refreshData: () => void;
  enableSave: boolean;
  saveLoading?: boolean;
};

const SubHeader: React.FC<SubHeaderType> = (props: SubHeaderType) => {
  const { title, saveData, refreshData, enableSave, saveLoading } = props;
  const { t } = useTranslation();
  return (
    <Flex
      className={"border-b border-lineColor"}
      gap="10px"
      style={{
        padding: "20px 40px 20px 40px",
      }}
    >
      <Flex vertical className="w-full">
        <Paragraph className="h1-bold text-o-title">{t(title)}</Paragraph>

        <Flex gap="12px" className="ml-auto">
          <Button
            style={{ padding: "8px 12px 8px 12px" }}
            className="h-[36px] rounded-[4px] text-sm  body-regular"
            ghost
            type="primary"
            onClick={refreshData}
            disabled={!enableSave}
          >
            {t("Reset")}
          </Button>

          <Button
            style={{
              padding: "8px 12px 8px 12px",
            }}
            className="h-[36px] rounded-[4px] text-white body-regular"
            type="primary"
            onClick={saveData}
            disabled={!enableSave}
            loading={saveLoading}
          >
            {t("Save")}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default SubHeader;
